import { h, defineComponent, SetupContext } from 'vue';
// @ts-ignore
import { BField } from 'buefy/dist/esm/field';
// @ts-ignore
import { BRadioButton } from 'buefy/dist/esm/radio';
import { ValidationError } from '@/entities/validation';
import { Field, FieldProps } from './Field';

export interface SegmentedButtonFieldOption {
  label: string;
  value: number;
  type: string;
}

export interface SegmentedButtonFieldProps {
  name: string;
  label: string;
  value: number;
  required: boolean;
  expanded: boolean;
  options: SegmentedButtonFieldOption[];
  errors: ValidationError[];
}

export const SegmentedButtonField = defineComponent<SegmentedButtonFieldProps>({
  name: 'SegmentedButtonField',
  props: ['name', 'label', 'value', 'required', 'expanded', 'options', 'errors'],
  setup(props, context: SetupContext) {
    return function render() {
      const fieldProps: FieldProps = {
        label: props.label,
        name: props.name,
        required: props.required,
        errors: props.errors,
      };
      return h(
        Field,
        { props: fieldProps },
        [h('div', {}, [
          h(BField, props.options.map(option => h(
            BRadioButton,
            {
              props: {
                expanded: props.expanded,
                type: option.type,
                value: props.value,
                nativeValue: option.value,
              },
              on: {
                input: (value: number) => {
                  context.emit('input', value);
                },
              },
            },
            option.label,
          ))),
        ])],
      );
    };
  },
});
